/**
 * Fonction utilitaire pour obtenir l'icône de tri appropriée
 * @param field - Le champ pour lequel on veut l'icône
 * @param currentField - Le champ actuellement trié
 * @param direction - La direction du tri actuel ("asc" | "desc")
 * @returns JSX.Element - L'icône SVG correspondante
 */
export const getSortIcon = (field: string, currentField: string, direction: "asc" | "desc") => {
  // Si ce n'est pas le champ actuellement trié, afficher l'icône neutre
  if (currentField !== field) {
    return (
      <svg aria-hidden="true" className="size-3.5 shrink-0 text-slate-400" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" />
      </svg>
    );
  }

  // Si c'est le champ trié et direction croissante
  if (direction === "asc") {
    return (
      <svg aria-hidden="true" className="size-3.5 shrink-0" fill="none" stroke="currentColor" strokeWidth={2.4} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
      </svg>
    );
  }

  // Si c'est le champ trié et direction décroissante
  return (
    <svg aria-hidden="true" className="size-3.5 shrink-0" fill="none" stroke="currentColor" strokeWidth={2.4} viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
    </svg>
  );
};

/**
 * Fonction utilitaire pour obtenir les classes CSS d'un bouton de tri
 * @param field - Le champ du bouton
 * @param currentField - Le champ actuellement trié
 * @returns string - Les classes CSS appropriées
 */
export const getSortButtonClasses = (field: string, currentField: string): string => {
  const baseClasses =
    "inline-flex cursor-pointer items-center gap-1.5 rounded-lg px-2.5 py-1.5 font-Nunito text-xs font-semibold whitespace-nowrap transition-colors focus-visible:ring-2 focus-visible:ring-indigo-200 focus-visible:outline-none";

  if (currentField === field) {
    return `${baseClasses} bg-indigo-600 text-white`;
  }

  return `${baseClasses} border border-slate-200 bg-white text-slate-600 hover:border-slate-300 hover:bg-slate-50`;
};
